/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForCostCenterAzure extends models.ServiceAccountNativeDetailsBaseForCostCenterCloud {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForCostCenterAzure");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForCostCenterAzure.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForCostCenterAzure>): ServiceAccountNativeDetailsForCostCenterAzure {
        let obj = Object.assign(new ServiceAccountNativeDetailsForCostCenterAzure(), model);
        ServiceAccountNativeDetailsForCostCenterAzure.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForCostCenterAzure>): ServiceAccountNativeDetailsForCostCenterAzure {
        if (!model) return null;
        return ServiceAccountNativeDetailsForCostCenterAzure.newInstance(<ServiceAccountNativeDetailsForCostCenterAzure> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForCostCenterAzure) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForCostCenterAzure.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForCostCenterAzure): boolean {
        if (models.ServiceAccountNativeDetailsBaseForCostCenterCloud.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForCostCenterAzure.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tenant Id
     */
    tenant_id: string;

}
